import { takeLeading } from 'redux-saga/effects'

const takes = ({ types, sagas }) => ([
    takeLeading(types.SEND_MESSAGE, sagas.sendMessage),
])

export default takes
